/**
 * Prices and subscriptions (the commercial console, ADR-0018 §4a), in
 * English. English is the source text: every other language is a faithful translation of it.
 */
export const billingEn = {
  "billing.tabs.aria": "Prices and subscriptions",
  "billing.tab.prices": "Prices",
  "billing.tab.promos": "Promotions",
  "billing.tab.discounts": "Discounts",
  "billing.refreshFailed": "The list could not be refreshed: it is shown as it was.",
  "billing.anyPlan": "Any plan",
  "billing.planWithInterval": "{name}, billed {interval}",
  "billing.interval.month": "monthly",
  "billing.interval.year": "yearly",
  "billing.window": "from {from} to {to}",
  "billing.window.endedEarly": "stopped on {date}",
  "billing.periods.whileSubscribed": "for as long as they stay subscribed",
  "billing.periods.count": "{count} paid periods",
  "billing.state.scheduled": "Scheduled",
  "billing.state.running": "Running",
  "billing.state.finished": "Finished",
  "billing.state.ended_early": "Stopped early",
  "billing.scope.pro": "One pro",
  "billing.scope.country": "A country",
  "billing.scope.category": "A trade",
  "billing.priceState.in_force": "In force",
  "billing.priceState.scheduled": "Scheduled",
  "billing.priceState.superseded": "Replaced",
  "billing.prices.intro": "A new price applies to new subscriptions only. A pro keeps the price they subscribed at.",
  "billing.prices.loading": "Loading prices…",
  "billing.prices.loadFailed": "The prices could not be loaded.",
  "billing.prices.empty": "No price has been set yet.",
  "billing.prices.unpriced": "With no price: {plans}. Nobody can subscribe to them.",
  "billing.prices.imported": "From the tier's original amount",
  "billing.promos.intro":
    "A promo lowers a plan's price in one country, for anyone who subscribes inside its window. A pro gets the single lowest price: a promo and a discount never add up.",
  "billing.promos.loading": "Loading promotions…",
  "billing.promos.loadFailed": "The promotions could not be loaded.",
  "billing.promos.empty": "No promotion for now.",
  "billing.discounts.intro":
    "A discount is a percentage off for one pro, a country or a trade. A pro gets the single lowest price: a discount and a promo never add up.",
  "billing.discounts.loading": "Loading discounts…",
  "billing.discounts.loadFailed": "The discounts could not be loaded.",
  "billing.discounts.empty": "No discount for now.",
  "billing.col.name": "Name",
  "billing.col.plan": "Plan",
  "billing.col.country": "Country",
  "billing.col.currency": "Currency",
  "billing.col.amount": "Amount",
  "billing.col.amountDue": "Still to pay",
  "billing.col.promoPrice": "Promo price",
  "billing.col.percentOff": "Off",
  "billing.col.periods": "Lasts",
  "billing.col.window": "Window",
  "billing.col.state": "State",
  "billing.col.status": "Payment status",
  "billing.col.subscribers": "Pros on it",
  "billing.col.createdBy": "Created by",
  "billing.col.setBy": "Set by",
  "billing.col.reason": "Reason",
  "billing.col.validFrom": "From",
  "billing.col.who": "Who for",
  "billing.col.actions": "Action",
  "billing.col.date": "When",
  "billing.col.period": "Period covered",
  "billing.col.provider": "Provider",
  "billing.col.eventKind": "Event",
  "billing.col.via": "Came in by",
  "billing.col.result": "Result",
  "billing.col.detail": "Detail",
  "billing.col.eventRef": "Event reference",
  "billing.action.setPrice": "Set a price",
  "billing.action.newPromo": "New promotion",
  "billing.action.newDiscount": "New discount",
  "billing.action.endNow": "End now",
  "billing.action.endPromo": "End the promotion",
  "billing.action.endDiscount": "End the discount",
  "billing.action.extendSubscription": "Extend",
  "billing.action.endSubscription": "End the subscription",
  "billing.dialog.setPrice.title": "Set a price",
  "billing.dialog.setPrice.body":
    "This price will apply to new subscriptions in that country. Pros already subscribed keep theirs.",
  "billing.dialog.newPromo.title": "New promotion",
  "billing.dialog.newPromo.body":
    "The promo price replaces the country's price during the window. A pro keeps it while they stay subscribed, up to the limit given.",
  "billing.dialog.newDiscount.title": "New discount",
  "billing.dialog.newDiscount.body":
    "Pick a single target: one pro, a country or a trade. A pro gets the single lowest price: a discount and a promo never add up.",
  "billing.dialog.endPromo.title": "End the promotion {subject}",
  "billing.dialog.endPromo.body": "Nobody new can take it. The pros already on it keep it.",
  "billing.dialog.endDiscount.title": "End the discount {subject}",
  "billing.dialog.endDiscount.body": "It will no longer apply to new subscriptions. The pros already on it keep it.",
  "billing.dialog.extendSubscription.title": "Extend {subject}",
  "billing.dialog.extendSubscription.body":
    "A goodwill gesture: access runs to the date you pick and a suspension is lifted. The pro's price does not change.",
  "billing.dialog.endSubscription.title": "End the subscription {subject}",
  "billing.dialog.endSubscription.body":
    "Access stops at once and the provider is told to stop charging. There is no refund: issue a credit from Paiements if one is due.",
  "billing.field.plan": "Plan",
  "billing.field.pickPlan": "Pick a plan",
  "billing.field.country": "Country",
  "billing.field.countryHint": "A two-letter code, for example GN.",
  "billing.field.currency": "Currency",
  "billing.field.currencyHint": "A three-letter code, for example GNF.",
  "billing.field.amount": "Price ({currency})",
  "billing.field.validFrom": "Starts on (optional)",
  "billing.field.validFromHint": "Leave it empty and the price applies at once. Never a past date.",
  "billing.field.name": "Name",
  "billing.field.nameHint": "What the team will see in the list, for example “Conakry launch”.",
  "billing.field.startsAt": "Starts",
  "billing.field.endsAt": "Ends",
  "billing.field.periods": "Number of periods (optional)",
  "billing.field.periodsHint": "Leave it empty and the pro keeps the price while they stay subscribed.",
  "billing.field.scope": "Who for",
  "billing.field.pro": "The pro",
  "billing.field.category": "Trade",
  "billing.field.pickCategory": "Pick a trade",
  "billing.field.percentOff": "Percentage off",
  "billing.field.paidThrough": "Extend until",
  "billing.field.paidThroughHint": "A date ahead. Access runs until then.",
  "billing.problem.reason": "Give a reason of at least {min} characters.",
  "billing.problem.plan": "Pick a plan.",
  "billing.problem.country": "Type a two-letter country code.",
  "billing.problem.currency": "Type a three-letter currency code.",
  "billing.problem.amount": "Type an amount above zero.",
  "billing.problem.validFrom": "Give a valid start date.",
  "billing.problem.backdated": "A price cannot start in the past.",
  "billing.problem.name": "Give a name of at least {min} characters.",
  "billing.problem.window": "Give a start and an end.",
  "billing.problem.windowOrder": "The end must come after the start.",
  "billing.problem.periods": "The number of periods must be a whole number above zero.",
  "billing.problem.pro": "Pick the pro it is for.",
  "billing.problem.category": "Pick a trade.",
  "billing.problem.percentOff": "The percentage must be a whole number between 1 and 100.",
  "billing.problem.paidThrough": "Give a valid end date.",
  "billing.problem.paidThroughPast": "The date must be ahead.",
  "billing.outcome.price": "Price recorded: {amount}, from {date}.",
  "billing.outcome.promoCreated": "Promotion “{name}” created.",
  "billing.outcome.promoEnded": "Promotion “{name}” stopped. The pros already on it keep it.",
  "billing.outcome.discountCreated": "Discount “{name}” created.",
  "billing.outcome.discountEnded": "Discount “{name}” stopped. The pros already on it keep it.",
  "billing.outcome.extended": "Subscription extended to {date}.",
  "billing.outcome.subscriptionEnded": "Subscription ended. Access is cut and the provider will not charge again.",
  "billing.error.stale": "This changed while you were looking. Reload it, check, then try again.",
  "billing.error.refused": "Refused: your roles do not include the feature this needs. Ask a manager for access.",
  "billing.error.invalid": "Refused: what was sent no longer fits. Reload and check.",
  "billing.error.outcomeUnknown":
    "No answer from the server: it may have been recorded. Try again: the same click cannot be applied twice.",
  "billing.refused.planNotPriced": "Refused: that plan has no price in that country yet. Set one first.",
  "billing.refused.invalidAmount": "Refused: the amount must be above zero.",
  "billing.refused.backdated": "Refused: a price cannot start in the past.",
  "billing.refused.priceVersionExists":
    "Refused: a version already starts at that moment for that plan and country. Reload the list.",
  "billing.refused.invalidWindow": "Refused: the window is not valid. The end must come after the start.",
  "billing.refused.alreadyOver": "Refused: this is already over. Reload the list.",
  "billing.refused.idempotencyKeyRequired":
    "Refused: the request went out without its key. Close the dialog and start again.",
  "billing.subscription.pending": "Pending",
  "billing.subscription.active": "Active",
  "billing.subscription.ending": "Not renewing",
  "billing.subscription.suspended": "Suspended",
  "billing.subscription.ended": "Ended",
  "billing.endReason.renewal_cancelled": "Renewal cancelled by the pro",
  "billing.endReason.unpaid": "Renewal not paid",
  "billing.endReason.checkout_abandoned": "Payment never finished",
  "billing.endReason.replaced": "Replaced by another subscription",
  "billing.endReason.ended_by_staff": "Ended by the team",
  "billing.endReason.ended_by_provider": "Ended by the provider",
  "billing.event.payment_succeeded": "Payment succeeded",
  "billing.event.payment_failed": "Payment failed",
  "billing.event.subscription_ended": "Subscription ended",
  "billing.via.webhook": "Provider webhook",
  "billing.via.poll": "Checked by Walliyo",
  "billing.via.return": "The pro coming back to the app",
  "billing.via.reconcile": "Reconciliation",
  "billing.result.applied": "Applied",
  "billing.result.conflict": "Conflict",
  "billing.result.ignored": "Ignored",
  "billing.priceInsteadOf": "{now} instead of {regular}",
  "billing.reductionWithPeriods": "{name} · {count} periods left",
  "billing.sub.loading": "Loading the subscription…",
  "billing.sub.loadFailed": "The subscription could not be loaded.",
  "billing.sub.none": "This pro has never subscribed.",
  "billing.sub.credit": "Credit",
  "billing.sub.noCredit": "None",
  "billing.sub.noRefunds":
    "There is no refund on a subscription. A gesture is a credit, issued from Paiements, taken off the next payment.",
  "billing.sub.creditLink": "Their payments, to issue a credit →",
  "billing.sub.discountLink": "Offer this pro a discount →",
  "billing.sub.since": "Started on {date}",
  "billing.sub.versionTitle": "The subscription version on screen: every write sends it.",
  "billing.sub.entitled": "Access on",
  "billing.sub.notEntitled": "No access",
  "billing.sub.provider": "Provider",
  "billing.sub.renewsAutomatically": "renews automatically",
  "billing.sub.paidByHand": "paid by hand by the pro",
  "billing.sub.country": "Country",
  "billing.sub.price": "Price now",
  "billing.sub.reduction": "Reduction",
  "billing.sub.nextPlan": "Plan change",
  "billing.sub.nextPlanValue": "changes to {plan} at the end of the period",
  "billing.sub.paidThrough": "Paid through",
  "billing.sub.renewalCancelled": "Renewal cancelled on",
  "billing.sub.graceEnds": "Grace period ends",
  "billing.sub.ended": "Ended on",
  "billing.sub.endReason": "Why it ended",
  "billing.sub.payments": "Payments",
  "billing.sub.noPayments": "No payment on this subscription.",
  "billing.sub.noPeriod": "Not covered yet",
  "billing.sub.events": "Provider events",
  "billing.sub.noEvents": "No provider event.",
  "billing.sub.actions": "Act on this subscription",
  "billing.sub.actionsFoot":
    "Extending is goodwill, ending is enforcement. Both ask for a reason and go to the audit log.",
} as const;
